import { type ComponentProps } from "react"
import { Grid, GridItem, type GridProps } from "@octopus-energy/coral/atoms"

type DataGridItemProps = { gridProps?: Omit<GridProps, "children"> } & ComponentProps<
    typeof GridItem
>

export function DataGridItem({ children, gridProps = {}, ...props }: DataGridItemProps) {
    return (
        <GridItem {...props}>
            <Grid
                gap="sm"
                {...gridProps}
            >
                {children}
            </Grid>
        </GridItem>
    )
}
